import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=0a9b1de6"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a9b1de6')) {
      api.createRecord('0a9b1de6', component.options)
    } else {
      api.reload('0a9b1de6', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=0a9b1de6", function () {
      api.rerender('0a9b1de6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appManage/layout.vue"
export default component.exports